import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "./useLocale";
import { withLocale } from "./config";

const localizeTo = (to, locale) => {
  if (typeof to === "string") {
    return withLocale(to, locale);
  }
  if (to && typeof to === "object") {
    return {
      ...to,
      pathname: withLocale(to.pathname || "/", locale),
    };
  }
  return withLocale("/", locale);
};

export const LocaleLink = ({ to, ...rest }) => {
  const locale = useLocale();
  return <Link to={localizeTo(to, locale)} {...rest} />;
};
